module.exports = __webpack_public_path__ + "img/MVCLogo.1990c84c.png";